import React from 'react';
import PropTypes from 'prop-types';
import '../styles/ParallaxModal.css';
import ProductMagnifiedGallery from './ProductMagnifiedGallery';
/**
 * This component will be used to display the image of the product in model
 * @todo Add "click to expand" feature.
 * @todo Add "click to close" feature.
 * 
 */
const ParallaxModel = ({ show, onClose, onClick, images, productTitle, index }) => {
    if (!show) {
        return null;
    }

    return (
        <div 
            className={'parallax-model'}
            onClick={onClose}>
            <div 
                className={'parallax-model--content'}
                onClick={onClick}>
                <ProductMagnifiedGallery
                    index={index}
                    onClose = {onClose}
                    productTitle={productTitle}
                    images={images}/>
            </div>
        </div>
    );
};

ParallaxModel.propTypes = {
    index: PropTypes.number,
    productTitle: PropTypes.string,
    onClick: PropTypes.func,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
    images: PropTypes.array
};


export default ParallaxModel;